<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" (resized)="onResized($event)">
   
    <iframe [style.width.px]="widthExp" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>
  
</div>
<div class="clearfix">
  <div class="pull-right">
    <button *ngIf="!loading" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
